import { useState } from "react";
import { Filtros, RespuestaInformeCMFDTO } from "../models/informeCMF";
import { getInformesCMF } from "../service/informesCMFService";
import { StatusCode } from "../../../../utils/enums";
import { AxiosResponse } from "axios";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";



export function useInformesCMF () {
    const [dataInformes, setDataInformes] = useState<RespuestaInformeCMFDTO[]>([]);
    const getInformes = async (data: Filtros) => {
        const response : AxiosResponse<ListResponseDto<RespuestaInformeCMFDTO>>= await getInformesCMF(data)
        if(response.status === StatusCode.Ok){
            setDataInformes(response.data.items)
        }else{
            setDataInformes([])
        }
    }
    return {
getInformes,
dataInformes
}
}
